<template>
    <section class="page-cabinet-transactions-list">
        <template v-if="cardsData && cardsData.length > 0">
<!--            <div class="page-cabinet-transactions-list__table">-->
<!--                <ui-table v-bind="tableData" />-->
<!--            </div>-->
            <div class="page-cabinet-transactions-list__cards">
<!--                <div class="page-cabinet-transactions-list__cards-header">
                    <div class="page-cabinet-transactions-list__cards-header-item">
                        Транзакция
                    </div>
                    <div class="page-cabinet-transactions-list__cards-header-item _sortable"
                        v-on:click="sort"
                        >
                        Дата
                        <div class="page-cabinet-transactions-list__cards-header-item-icon">
                            <span class="icon icon-sort-desc" />
                        </div>
                    </div>
                </div>-->
                <div class="page-cabinet-transactions-list__cards-list">
                    <div class="page-cabinet-transactions-list__cards-list-item"
                        v-for="(card, index) in groupedCards"
                        v-bind:key="index"
                        >
                        <page-cabinet-transactions-list-card
                            v-bind="card"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="page-cabinet-transactions-list__empty"
                v-text="'Записей не найдено'"
            />
        </template>
    </section>
</template>

<script>
import utils from '~/utils';
import moment from 'moment';

export default {
    name: 'page-cabinet-transactions-list',
    computed: {
        items() {
            const items = this.$store.getters['transfers/items'];
            if (!items) {
                return null;
            }
            return items;
        },
        currency() {
            return this.$store.getters['site/currency'];
        },
        tableData() {
            const columns = [
                {
                    title: 'Тип транзакции',
                    style: { flex: '1 0 447px' },
                },
                {
                    title: 'Сумма',
                    style: { flex: '0 0 130px', display: 'flex', justifyContent: 'flex-end', paddingRight: '24px' },
                },
                {
                    title: 'Дата',
                    style: { flex: '0 0 80px' },
                },
            ];
            if (!this.items) {
                return {
                    columns,
                    rows: [],
                };
            }
            const rows = [];
            if (this.items) {
                this.items.forEach(item => {
                    rows.push([
                        {
                            props: {
                                text: item.typeName,
                            },
                        },
                        {
                            props: {
                                text: item.amount ? `${utils.formats.formatNumberWithSpaces(item.amount)} ${this.currency.name.short}` : null,
                            },
                        },
                        {
                            type: 'component',
                            component: 'ui-table-cell-date',
                            props: {
                                date: item.date,
                            },
                        },
                    ]);
                });
            }
            return {
                columns,
                rows,
            };
        },
        cardsData() {
            if (this.items) {
                return this.items.map(item => {
                    return {
                        // title: item.description,
                        type: item.typeName,
                        date: item.date,
                        amount: item.amount,
                        sum: item.amount
                            ? `${item.amount > 0 ? '+' : ''}${utils.formats.formatNumberWithSpaces(item.amount)} ${this.currency.name.short}`
                            : null,
                    };
                });
            } else {
                return [];
            }
        },
        groupedCards() {
            const grouped = this.cardsData?.reduce((acc, item) => {
                const momentDate = moment(item.date);

                const year = momentDate.year();
                const currentYear = new Date().getFullYear();
                const day = item.date.split('T')[0];

                if (!acc[day]) {
                    acc[day] = {
                        day: {
                            date: momentDate.date(),
                            month: momentDate.format('MMMM'),
                            year: year !== currentYear ? momentDate.year() : null,
                            dayOfWeek: momentDate.format('dddd'),
                        },
                        items: [],
                    };
                }
                acc[day].items.push(item);

                return acc;
            }, {});

            const groupedArray = Object.entries(grouped ?? {})?.map(([day, items]) => ({
                day: items.day,
                items: items.items,
            }));

            return groupedArray || [];
        },
    },
    methods: {
        sort() {
            // console.log('sort');
        },
    },
    mounted() {
        this.$store.dispatch('transfers/getItems', { is_transaction: true });
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-transactions-list {
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding-top: 24px;
    padding-bottom: 36px;
    &__table {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 700px;
        // height: ~'calc(100vh - 77px)'; // 77px - common-header height
    }
    &__cards {
        display: block;

        &-list {
            display: flex;
            flex-direction: column;
            gap: 16px;

            width: ~'calc(100% + 18px)';
            max-width: 638px;
            // height: ~'calc(100vh - 60px - 56px - 42px)'; // 60px - common-header (mobile)
            // 56px - layout-cabinet-sideblock-menu
            // 42px - page-cabinet-transactions-list__cards-header
            padding-right: 18px;
            padding-bottom: 40px;
            margin-right: -18px;
            overflow: auto;
            &-item {
                margin-bottom: 8px;
            }
        }
    }
    &__empty {
        .typography-small();

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 100%;
        padding-right: 135px;
        margin: auto;

        color: @color-gray-main;
    }
    @media @media-md-down {
        &__table {
            display: none;
        }
        &__cards {
            display: block;
            &-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                height: 42px;
                padding-top: 10px;
                &-item {
                    .typography-caption();

                    flex: 0 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    padding: 0 16px;

                    font-weight: bold;
                    text-transform: uppercase;
                    &._sortable {
                        cursor: pointer;
                    }
                    &-icon {
                        margin-left: 6px;
                        font-size: 1.8rem;
                    }
                }
            }
        }
        &__empty {
            padding-right: 0;
        }
    }
}
</style>
